import { useMemo } from 'react'
import { SearchableSelect } from '../../../../../../../generic/ui/SearchableSelect/SearchableSelect'
import RulerIcon from '../../../../../../../generic/icons/IconLib/RulerIcon'

type Props = {
  handleSelect: (id: number) => void
  defaultType?: number
  disabled?: boolean
  tabIndex?: number
  placeholder?: string
}

interface TypeCalcOption {
  id: number
  desc: string
}

const TYPES: TypeCalcOption[] = [
  { id: 0, desc: 'משקל' },
  { id: 1, desc: 'כמות' },
]

const TypeCalcSelect = ({
  handleSelect,
  defaultType,
  disabled,
  placeholder = 'בחר סוג חישוב',
}: Props) => {
  const value = useMemo(
    () => TYPES.find((t) => t.id === defaultType) ?? null,
    [defaultType],
  )

  return (
    <SearchableSelect<TypeCalcOption>
      items={TYPES}
      value={value}
      onSelect={(t) => handleSelect(t ? t.id : -1)}
      getKey={(t) => t.id}
      getLabel={(t) => t.desc}
      placeholder={placeholder}
      disabled={disabled}
      leadingIcon={<RulerIcon />}
      emptyLabel='אין סוגים מתאימים'
    />
  )
}

export default TypeCalcSelect
